<template>
  <div id="dashboard-analytics">    
    <vs-popup fullscreen :title="popupLista.titulo" :active.sync="popupLista.exibir" >
      <div class="text-center" >          
        <vs-table :data="popupLista.lista" noDataText="...">
          <template slot="thead">
              <vs-th sort-key="indextr" style="text-align: center !important;">#</vs-th>
              <vs-th sort-key="tipo"><p style="width:100%; text-align: center">Tipo</p></vs-th>
              <vs-th sort-key="nome"><p style="width:100%; text-align: center">Nome</p></vs-th>
              <vs-th sort-key="data"><p style="width:100%; text-align: center">Data</p></vs-th>                          
              <vs-th sort-key="data"><p style="width:100%; text-align: center">Valor</p></vs-th>   
              <vs-th sort-key="tipo"><p style="width:100%; text-align: center">Placa</p></vs-th>
          </template>

          <template slot-scope="{data}"> 
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr" >
                <vs-td :data="indextr">
                      <small>{{indextr+1}}</small>                   
                  </vs-td>
                  <vs-td :data="tr.tipo">
                      <small>{{tr.tipo}}</small>                   
                  </vs-td>
                  <vs-td :data="tr.nome">
                      <small>{{tr.nome}}</small>                   
                  </vs-td>
                  <vs-td :data="tr.dataFormatada">
                      <small>{{tr.dataFormatada}}</small>
                  </vs-td> 
                  <vs-td :data="tr.valor">
                      <small>{{formatarNumero(tr.valor)}}</small>
                  </vs-td>
                  <vs-td :data="tr.placa" v-if="tr.placa">
                      <small>{{tr.placa}} <span v-if="tr.labelVeiculo"> / {{tr.labelVeiculo}} </span></small>                   
                  </vs-td>                    
                  <vs-td :data="tr.veiculo.placa" v-if="tr.veiculo && tr.veiculo.placa">
                      <small>{{tr.veiculo.placa}} <span v-if="tr.veiculo.labelVeiculo"> / {{tr.veiculo.labelVeiculo}} </span></small>                   
                  </vs-td>                    
              </vs-tr>
          </template>
        </vs-table> 
      </div>
    </vs-popup>

    <div class="w-full flex items-center justify-center mb-2">
        <h5> Total de Despesas - 12 últimos meses</h5>                          
        <h2 class="ml-4 font-bold">R$ {{ getTotalDespesa12MesesFormatado}}</h2>
    </div>                               
    <vs-row>        
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">                      
              <div slot="header">
                    <h5> Total de Despesas por Tipo - 12 meses </h5>
              </div>
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in totalListaDespesasPorTipo" :key="indice">
                    <div class="vx-col flex w-full">                                                            
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaDespesaVeiculo12Mes(null, itemGrafico.tipo)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>                        
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">   
              <div slot="header">
                  <h5> Total de Despesas por Veículo </h5>
              </div>                   
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in listaTotalDespesasSomatorioPorVeiculo" :key="indice">
                    <div class="vx-col flex w-full">
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaDespesaVeiculo12Mes(itemGrafico.id)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>                        
                    </div>                        
              </div>
            </vs-card>
        </vs-col>
    </vs-row>
    <div class="w-full flex items-center justify-center mb-4">
        <h5> Total de Receitas - 12 últimos meses  </h5>
        <h2 class="ml-4 font-bold">R$ {{ getTotalReceita12MesesFormatado}}</h2>
    </div>
    <vs-row>        
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">                      
              <div slot="header">
                    <h5> Total de Receitas por Tipo - 12 meses </h5>
              </div>
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in totalListaReceitasPorTipo" :key="indice">
                <div class="vx-col flex w-full">
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaReceitaVeiculo12Mes(null, itemGrafico.tipo)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>                        
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">   
              <div slot="header">
                    <h5> Total de Receitas por Veículo</h5>
              </div>                   
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in listaTotalReceitasSomatorioPorVeiculo" :key="indice">
                    <div class="vx-col flex w-full">
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaReceitaVeiculo12Mes(itemGrafico.id)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>                        
                    </div>                         
              </div>
            </vs-card>
        </vs-col>
    </vs-row> 
    <vs-row class="mt-1">
        <div class="vx-col w-full">
          <vs-card>
              <vue-apex-charts type=bar height=400 :options="graficoDespesasDo12UltimosMes.chartOptions" :series="graficoDespesasDo12UltimosMes.series" />
              <div class="flex">
                  <h5 class="mr-5 flex "> Despesas x Receitas dos 12 últimos meses </h5>
                  <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>Receitas R$ {{ getTotalReceita12MesesFormatado }}</span></span>
                  <span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>Despesas R$ {{ getTotalDespesa12MesesFormatado }}</span></span>
                  <span class="flex items-center ml-4"><feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-2" /><span>Clique no mês de uma receita/despesa para atualizar os quadros abaixo. </span></span>
              </div>
          </vs-card>
        </div>
    </vs-row>
    <div class="w-full flex items-center justify-center mb-4">
        <h5> Despesa Total - {{labelMes}} </h5>
        <h2 class="ml-4 font-bold">{{ getValorTotalDespesasFormatado}}</h2>
        <p class="text-xl font-medium flex ml-5">(
          <span :class="{'text-danger': (valorTotalDespesa > valorTotalDespesaMesAnterior), 'text-success': (valorTotalDespesa < valorTotalDespesaMesAnterior),}"> {{(valorTotalDespesa > valorTotalDespesaMesAnterior ? '+' : '')}} {{getPercentualDiferencaDespesas}}</span>
          <small v-if="valorTotalDespesaMesAnterior" class="mt-1 ml-1"> % comparado ao mês anterior </small>                                  
          <small v-if="!valorTotalDespesaMesAnterior" class="mt-1 ml-1"> nenhuma despesa no mês anterior </small>
          )
        </p>
    </div>
    <vs-row>        
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">                      
              <div slot="header">
                    <h5> Despesas por Tipo - {{labelMes}} </h5>
              </div>
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in graficoDespesasDoMes.analyticsData" :key="indice" id="div2-with-loading">
                    <div class="vx-col w-full flex">                                                            
                          <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaDespesaVeiculoMes(null, itemGrafico.tipo)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>                          
                          <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>  
                        
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">   
              <div slot="header">
                    <h5> Despesas por Veículo - {{labelMes}} </h5>
              </div>                   
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in graficoDespesasDoMes.analyticsDataPorVeiculo" :key="indice">
                    <div class="vx-col w-full flex">
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaDespesaVeiculoMes(itemGrafico.id)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>  
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
    </vs-row>  
    <div class="w-full flex items-center justify-center mb-4">
        <h5> Receitas Total - {{labelMes}} </h5>
        <h2 class="ml-4 font-bold">{{ getValorTotalReceitasFormatado}}</h2>
        <p class="text-xl font-medium flex ml-5">(
          <span :class="{'text-success': (valorTotalReceita > valorTotalReceitaMesAnterior), 'text-danger': (valorTotalReceita < valorTotalReceitaMesAnterior),}"> {{(valorTotalReceita > valorTotalReceitaMesAnterior ? '+' : '')}} {{getPercentualDiferencaReceitas}}</span>
          <small v-if="valorTotalReceitaMesAnterior" class="mt-1 ml-1"> % comparado ao mês anterior </small>                                  
          <small v-if="!valorTotalReceitaMesAnterior" class="mt-1 ml-1"> nenhuma receita no mês anterior </small>
          )
        </p>
    </div>
    <vs-row>        
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">                      
              <div slot="header">
                    <h5> Receitas por Tipo - {{labelMes}} </h5>
              </div>
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in graficoReceitasDoMes.analyticsData" :key="indice">
                    <div class="vx-col w-full flex">                                                            
                          <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaReceitaVeiculo12Mes(null, itemGrafico.tipo)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                          <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>                          
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card fixedHeight class="ml-3 p-1" style="max-height: 45vh; overflow: auto;">   
              <div slot="header">
                    <h5> Receitas por Veículo - {{labelMes}} </h5>
              </div>                   
              <div class="vx-row mt-1" v-for="(itemGrafico, indice) in graficoReceitasDoMes.analyticsDataPorVeiculo" :key="indice">
                    <div class="vx-col w-full flex">
                        <p class="font-bold text-primary" :style="{ cursor: 'pointer' }" v-on:click="fetchListaReceitaVeiculo12Mes(itemGrafico.id)">{{indice+1}} - {{ itemGrafico.tipo.toUpperCase() }}</p>
                        <div class="flex items-center ml-auto">                                                                                            
                            <p class="ml-auto mr-4"> {{formatarNumero(itemGrafico.percentual)}} %</p>
                            <p class="font-bold"> R$ {{ formatarNumero(itemGrafico.total) }}</p>                                
                        </div>  
                    </div>                          
              </div>
            </vs-card>
        </vs-col>
    </vs-row>               
  </div>
</template>

<script>
import axios from "@/axios.js"
import generico from '@/generico.js'
import VueApexCharts from 'vue-apexcharts'

export default {
    data() {
        return {                    
          graficoDespesasDo12UltimosMes: {
               series: [{
                   name: 'Receitas',
                   data: []
               }, {
                   name: 'Despesas',
                   data: []
               }],
              chartOptions: {
                  grid: {
                      borderColor: '#ebebeb',
                      padding: {
                          left: 0,
                          right: 0
                      }
                  },
                  legend: {
                      show: false,
                  },
                  dataLabels: {
                      enabled: true,  
                      
                      offsetY: -20,
                      style: {
                        fontSize: '9px',
                        colors: ["#000000"]
                      },                      
                      formatter: function (y) {                        
                        return "R$ " + generico.formatarNumero(y);
                      },
                      hideOverflowingLabels: true
                  },
                  chart: {
                      id: 'grafico12Meses',
                      stacked: true,
                      type: 'bar',
                      toolbar: { show: true },
                      events: {
                          dataPointSelection: (e, chart, opts) => {
                              this.carregarDados(opts.dataPointIndex);
                          }
                      }
                  },
                  colors: ['#7367F0', '#EA5455'],
                  plotOptions: {
                      bar: {                          
                          columnWidth: '50%',                          
                          dataLabels: {      
                            position: 'top',                              
                            hideOverflowingLabels: true
                          }
                      }
                      
                  },
                  xaxis: {
                      labels: {
                          style: {
                              cssClass: 'text-grey fill-current',
                          }
                      },
                      axisTicks: {
                          show: false,
                      },
                      categories: [],
                      axisBorder: {
                          show: true,
                      },
                  },
                  yaxis: {
                      tickAmount: 5,
                      labels: {
                          style: {
                              cssClass: 'text-grey fill-current',
                          },                          
                          formatter: function (y) {
                            return generico.formatarNumero(y);
                          }
                      },
                  },
                  tooltip: {
                      x: { show: false },
                      y: {
                        formatter: function (val) {
                          return generico.formatarMoedaReal(val)
                        }
                      }
                  },
              }
          },
          dadosDespesa: [],
          dadosReceita: [],
          graficoDespesasDoMes: {
              analyticsData: [],
              analyticsDataPorVeiculo: []              
          }, 
          graficoReceitasDoMes: {
              analyticsData: [],
              analyticsDataPorVeiculo: []
          },         
          pollingIntervalObj : null ,
          valorTotalDespesa: 0,        
          valorTotalDespesaMesAnterior: 0,   
          valorTotalDespesa12Meses: 0,
          valorTotalReceita: 0,        
          valorTotalReceitaMesAnterior: 0,   
          valorTotalReceita12Meses: 0,        
          listaCategorias: [],       
          totalListaDespesasPorTipo: [],
          totalListaReceitasPorTipo: [],
          listaTotalDespesasSomatorioPorVeiculo: [],
          listaTotalReceitasSomatorioPorVeiculo: [],
          labelMes: null,          
          publicPath: process.env.BASE_URL,
          popupLista : {
            exibir: false,
            titulo: null,
            lista : []
          }
        }
    },
    components: {
        VueApexCharts        
    },
    created() {      
     
    },
    computed: {
      getTotalReceita12MesesFormatado(){
          return generico.formatarNumero(this.valorTotalReceita12Meses);
      },
      getTotalDespesa12MesesFormatado(){
          return generico.formatarNumero(this.valorTotalDespesa12Meses);
      },
      getDataFinalAgendaEventos() {
        var date = new Date();
        let dataFromTS = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());        
        return  generico.zeroPad(dataFromTS.getUTCDate(),2) + "-" + generico.zeroPad((dataFromTS.getUTCMonth() + 1),2) + "-" + dataFromTS.getUTCFullYear();        
      },
      listaVeiculos() {
        return this.$store.state.veiculos;
      },      
      getValorTotalDespesasFormatado() {
        return generico.formatarMoedaReal(this.valorTotalDespesa);
      },
      getPercentualDiferencaDespesas() { 
        if (this.valorTotalDespesa && this.valorTotalDespesaMesAnterior) {       
          return generico.formatarNumero(((this.valorTotalDespesa/this.valorTotalDespesaMesAnterior) - 1)*100);
        } else {
          return "";
        }
      },  
      getValorTotalReceitasFormatado() {
        return generico.formatarMoedaReal(this.valorTotalReceita);
      },
      getPercentualDiferencaReceitas() { 
        if (this.valorTotalReceita && this.valorTotalReceitaMesAnterior) {       
          return generico.formatarNumero(((this.valorTotalReceita/this.valorTotalReceitaMesAnterior) - 1)*100);
        } else {
          return "";
        }
      },     
    },
    mounted() {          
        this.fetchDados(null);                
    },
    beforeDestroy() {    
      clearInterval(this.pollingIntervalObj);    
    },
    methods: { 
      carregarDados(indiceGrafico) {     
        this.$vs.loading();   
        this.labelMes = this.listaCategorias[indiceGrafico]
        this.fetchDados(this.listaCategorias[indiceGrafico]);
      },
      formatarNumero(valor) {
        return generico.formatarNumero(valor);
      },
      
      fetchDados(pMesAno) {         
            const params = new URLSearchParams(); 
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            if (pMesAno) {
              params.append('mesAno', pMesAno);
            }

            axios.post("/rest/DashboardDespesas/Carregar", params, {              
                    credentials: 'include',
                    responseEncoding: 'iso88591',
                    withCredentials: true } )
            .then((response) => {
              this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {
                    var self_ = this;                     
                    var j=0;         

                    if (response.data.DashboardDespesas.graficoDespesasDoMes.hasOwnProperty("item")) {
                        self_.graficoDespesasDoMes.analyticsData = [];
                        
                        self_.dadosDespesa = [];
                        let totalDespesas = 0;

                        if (Array.isArray(response.data.DashboardDespesas.graficoDespesasDoMes.item)) {
                          for(j=0; j < response.data.DashboardDespesas.graficoDespesasDoMes.item.length; j++) {
                            totalDespesas = totalDespesas + parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item[j].total);
                          }
                          for(j=0; j < response.data.DashboardDespesas.graficoDespesasDoMes.item.length; j++) {
                              self_.dadosDespesa.push(parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item[j].total));                            
                              self_.graficoDespesasDoMes.analyticsData.push({tipo: response.data.DashboardDespesas.graficoDespesasDoMes.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item[j].total)/totalDespesas*100});                              
                          }
                        } else {
                          totalDespesas = totalDespesas + parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item.total);                          
                          self_.dadosDespesa.push(parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item.total)); 
                          self_.graficoDespesasDoMes.analyticsData.push({tipo: response.data.DashboardDespesas.graficoDespesasDoMes.item.status, qtd: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item.qtd), total: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item.total), percentual: parseFloat(response.data.DashboardDespesas.graficoDespesasDoMes.item.total)/totalDespesas*100});                          
                        }
                        
                        self_.valorTotalDespesa = totalDespesas;
                        self_.valorTotalDespesaMesAnterior = response.data.DashboardDespesas.valorDespesasMesAnterior;                        
                    } else {
                      self_.graficoDespesasDoMes.analyticsData = [];
                      self_.dadosDespesa = [];
   
                      self_.valorTotalDespesa = 0;
                      self_.valorTotalDespesaMesAnterior = response.data.DashboardDespesas.valorDespesasMesAnterior; 
                    }

                    if (response.data.DashboardDespesas.graficoReceitasDoMes.hasOwnProperty("item")) {
                        self_.graficoReceitasDoMes.analyticsData = [];
                        
                        self_.dadosReceita = [];
                        let totalReceitas = 0;

                        if (Array.isArray(response.data.DashboardDespesas.graficoReceitasDoMes.item)) {
                          for(j=0; j < response.data.DashboardDespesas.graficoReceitasDoMes.item.length; j++) {
                            totalReceitas = totalReceitas + parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item[j].total);
                          }
                          for(j=0; j < response.data.DashboardDespesas.graficoReceitasDoMes.item.length; j++) {
                              self_.dadosReceita.push(response.data.DashboardDespesas.graficoReceitasDoMes.item[j].total);                            
                              self_.graficoReceitasDoMes.analyticsData.push({tipo: response.data.DashboardDespesas.graficoReceitasDoMes.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item[j].total)/totalReceitas*100});                              
                          }
                        } else {
                          totalReceitas = totalReceitas + parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item.total);                          
                          self_.dadosReceita.push(parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item.total)); 
                          self_.graficoReceitasDoMes.analyticsData.push({tipo: response.data.DashboardDespesas.graficoReceitasDoMes.item.status, qtd: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item.qtd), total: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item.total), percentual: parseFloat(response.data.DashboardDespesas.graficoReceitasDoMes.item.total)/totalReceitas*100});                          
                        }
                        
                        self_.valorTotalReceita = totalReceitas;
                        self_.valorTotalReceitaMesAnterior = response.data.DashboardDespesas.valorReceitasMesAnterior;                        
                    } else {
                      self_.graficoReceitasDoMes.analyticsData = [];                        
                      self_.dadosReceita = [];
                      self_.valorTotalReceita = 0;
                      self_.valorTotalReceitaMesAnterior = response.data.DashboardDespesas.valorReceitasMesAnterior;
                    }

                    if (response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.hasOwnProperty("item")) {
                        self_.graficoDespesasDoMes.analyticsDataPorVeiculo = [];
                                            
                        let totalDespesas = 0;

                        if (Array.isArray(response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item)) {
                          for(j=0; j < response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.length; j++) {
                            totalDespesas = totalDespesas + parseFloat(response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].total);
                          }
                          for(j=0; j < response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.length; j++) {
                              self_.dadosDespesa.push(response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].total);  
                              
                              self_.graficoDespesasDoMes.analyticsDataPorVeiculo.push({id: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].id, tipo: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].status, qtd: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].qtd, total: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].total, percentual: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item[j].total/totalDespesas*100});
                              
                          }
                        } else {
                          totalDespesas = totalDespesas + response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.total;                          
                          self_.dadosDespesa.push(response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.total);                            
                          self_.graficoDespesasDoMes.analyticsDataPorVeiculo.push({id: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.id, tipo: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.status, qtd: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.qtd, total: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.total, percentual: response.data.DashboardDespesas.listaDespesasSomatorioPorVeiculo.item.total/totalDespesas*100});                          
                        }                        
                    } else {
                        self_.graficoDespesasDoMes.analyticsDataPorVeiculo = [];
                    }

                    if (response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.hasOwnProperty("item")) {
                        self_.graficoReceitasDoMes.analyticsDataPorVeiculo = [];
                                            
                        let totalReceitas = 0;

                        if (Array.isArray(response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item)) {
                          for(j=0; j < response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.length; j++) {
                            totalReceitas = totalReceitas + parseFloat(response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].total);
                          }
                          for(j=0; j < response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.length; j++) {
                              self_.dadosReceita.push(response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].total);  
                              
                              self_.graficoReceitasDoMes.analyticsDataPorVeiculo.push({id: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].id, tipo: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].status, qtd: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].qtd, total: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].total, percentual: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item[j].total/totalReceitas*100});
                              
                          }
                        } else {
                          totalReceitas = totalReceitas + response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.total;                          
                          self_.dadosReceita.push(response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.total);                            
                          self_.graficoReceitasDoMes.analyticsDataPorVeiculo.push({id: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.id, tipo: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.status, qtd: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.qtd, total: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.total, percentual: response.data.DashboardDespesas.listaReceitasSomatorioPorVeiculo.item.total/totalReceitas*100});                          
                        }                        
                    } else {
                      self_.graficoReceitasDoMes.analyticsDataPorVeiculo = [];
                    }

                    if (response.data.DashboardDespesas.graficoDespesasDo12UltimosMes.hasOwnProperty("item")) {
                        self_.graficoDespesasDo12UltimosMes.analyticsData = [];
                        let listaCategorias = [];
                        let dadosDespesa = [];
                        let dadosReceitas = [];

                        self_.valorTotalDespesa12Meses = 0;
                        self_.valorTotalReceita12Meses = 0;
                        
                        for(j=0; j < response.data.DashboardDespesas.graficoDespesasDo12UltimosMes.item.length; j++) {
                            dadosDespesa.push(parseFloat(response.data.DashboardDespesas.graficoDespesasDo12UltimosMes.item[j].total));  
                            listaCategorias.push(response.data.DashboardDespesas.graficoDespesasDo12UltimosMes.item[j].status);  
                            dadosReceitas.push(parseFloat(response.data.DashboardDespesas.graficoReceitasDo12UltimosMes.item[j].total));  

                            self_.valorTotalDespesa12Meses = self_.valorTotalDespesa12Meses + parseFloat(response.data.DashboardDespesas.graficoDespesasDo12UltimosMes.item[j].total);
                            self_.valorTotalReceita12Meses = self_.valorTotalReceita12Meses + parseFloat(response.data.DashboardDespesas.graficoReceitasDo12UltimosMes.item[j].total);
                        }

                        self_.graficoDespesasDo12UltimosMes.series = [{ name: 'Receitas', data: dadosReceitas}, { name: 'Despesas', data: dadosDespesa}];
                        
                        if (!this.listaCategorias.length) {
                          this.listaCategorias.push(...listaCategorias);
                          self_.graficoDespesasDo12UltimosMes.chartOptions.xaxis.categories.push(...listaCategorias);
                          this.labelMes = this.listaCategorias[this.listaCategorias.length-1];                          
                        }
                        
                    } else {
                        self_.graficoDespesasDo12UltimosMes.analyticsData = [];                                                                       
                    }      
                                        
                    // Lista Despesas Por Tipo
                    while (self_.totalListaDespesasPorTipo.length) {
                      self_.totalListaDespesasPorTipo.pop();
                    }
                    if (response.data.DashboardDespesas.listaTotalDespesas12Meses.hasOwnProperty("item")) {
                       if (Array.isArray(response.data.DashboardDespesas.listaTotalDespesas12Meses.item)) {                          
                          for(j=0; j < response.data.DashboardDespesas.listaTotalDespesas12Meses.item.length; j++) {                              
                            self_.totalListaDespesasPorTipo.push({tipo: response.data.DashboardDespesas.listaTotalDespesas12Meses.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item[j].total)/self_.valorTotalDespesa12Meses*-100});                              
                          }
                        } else {                          
                            self_.totalListaDespesasPorTipo.push({tipo: response.data.DashboardDespesas.listaTotalDespesas12Meses.item.status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item.qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item.total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalDespesas12Meses.item.total)/self_.valorTotalDespesa12Meses*-100});                              
                        }
                    }

                    while (self_.totalListaReceitasPorTipo.length) {
                      self_.totalListaReceitasPorTipo.pop();
                    }
                    if (response.data.DashboardDespesas.listaTotalReceitas12Meses.hasOwnProperty("item")) {
                       if (Array.isArray(response.data.DashboardDespesas.listaTotalReceitas12Meses.item)) {                          
                          for(j=0; j < response.data.DashboardDespesas.listaTotalReceitas12Meses.item.length; j++) {                              
                            self_.totalListaReceitasPorTipo.push({tipo: response.data.DashboardDespesas.listaTotalReceitas12Meses.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item[j].total)/self_.valorTotalReceita12Meses*100});                              
                          }
                        } else {                          
                            self_.totalListaReceitasPorTipo.push({tipo: response.data.DashboardDespesas.listaTotalReceitas12Meses.item.status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item.qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item.total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalReceitas12Meses.item.total)/self_.valorTotalReceita12Meses*100});                              
                        }
                    }

                    while (self_.listaTotalDespesasSomatorioPorVeiculo.length) {
                      self_.listaTotalDespesasSomatorioPorVeiculo.pop();
                    }
                    if (response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.hasOwnProperty("item")) {
                       if (Array.isArray(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item)) {                          
                          for(j=0; j < response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.length; j++) {                              
                            self_.listaTotalDespesasSomatorioPorVeiculo.push({id: response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item[j].id, tipo: response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item[j].total)/self_.valorTotalDespesa12Meses*-100});                              
                          }
                        } else {                          
                            self_.listaTotalDespesasSomatorioPorVeiculo.push({id: response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.id, tipo: response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalDespesasSomatorioPorVeiculo.item.total)/self_.valorTotalDespesa12Meses*-100});                              
                        }
                    }

                    while (self_.listaTotalReceitasSomatorioPorVeiculo.length) {
                      self_.listaTotalReceitasSomatorioPorVeiculo.pop();
                    }
                    if (response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.hasOwnProperty("item")) {
                       if (Array.isArray(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item)) {                          
                          for(j=0; j < response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.length; j++) {                              
                            self_.listaTotalReceitasSomatorioPorVeiculo.push({id: response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item[j].id, tipo: response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item[j].status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item[j].qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item[j].total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item[j].total)/self_.valorTotalReceita12Meses*100});                              
                          }
                        } else {                          
                            self_.listaTotalReceitasSomatorioPorVeiculo.push({id: response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.id, tipo: response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.status, qtd: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.qtd), total: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.total), percentual: parseFloat(response.data.DashboardDespesas.listaTotalReceitasSomatorioPorVeiculo.item.total)/self_.valorTotalReceita12Meses*100});                              
                        }
                    }
                }                
            })
            .catch((error) => { 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
                this.$vs.loading.close();
            })    
      },  
      fetchListaReceitaVeiculoMes(idVeiculo, tipoDespesa) {            
        const parts = this.labelMes.split('-').map(Number);        
        let month = parseInt(parts[0]);
        let year = parseInt(parts[1]);
        
        let dataInicio = new Date(year, month - 1, 1);        
        let dataFim = new Date(year, month, 0);       
        dataInicio.setHours(0, 0, 0, 0);
        dataFim.setHours(23, 59, 59, 999); 

        this.fetchListaReceitaVeiculo(idVeiculo, dataInicio, dataFim, tipoDespesa);
      },
      fetchListaReceitaVeiculo12Mes(idVeiculo, tipoDespesa) {  
        const today = new Date();
        const dataInicio = new Date(today.getFullYear(), today.getMonth() - 11, 1);        
        const dataFim = new Date(today.getFullYear(), today.getMonth() + 1, 0);        

        dataInicio.setHours(0, 0, 0, 0);
        dataFim.setHours(23, 59, 59, 999); 
        this.fetchListaReceitaVeiculo(idVeiculo, dataInicio, dataFim, tipoDespesa);
      },  
      fetchListaReceitaVeiculo(idVeiculo, dataInicio, dataFim, tipoReceita) {                 
        const params = new URLSearchParams();
        params.append('pagina', -1);
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        if (idVeiculo) {
          params.append('veiculo.id', idVeiculo);
          params.append('idVeiculo', idVeiculo);
        }

        if (tipoReceita) {
          params.append('tipo', tipoReceita);
        }
       
        params.append('dataInicioPesquisa', generico.formatarTimestampParaYMD(dataInicio.getTime()));
        params.append('dataFimPesquisa', generico.formatarTimestampParaYMD(dataFim.getTime()));  

        axios.post("/rest/ReceitaVeiculo/Listar", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                
                this.popupLista.exibir = true;
                this.popupLista.titulo = "Lista Receitas";                
                if (response.data.Resultado.quantidade > 1) {
                   this.popupLista.lista = response.data.Resultado.lista.item;
                } else if (response.data.Resultado.quantidade === 1) {
                  this.popupLista.lista = [];
                  this.popupLista.lista.push(response.data.Resultado.lista.item);
                } else {
                  this.popupLista.lista = [];
                }

            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error); 
        })    
                          
      },
      fetchListaDespesaVeiculoMes(idVeiculo, tipoDespesa) {            
        const parts = this.labelMes.split('-').map(Number);        
        let month = parseInt(parts[0]);
        let year = parseInt(parts[1]);
        let dataInicio = new Date(year, month - 1, 1);        
        let dataFim = new Date(year, month, 0);       
        dataInicio.setHours(0, 0, 0, 0);
        dataFim.setHours(23, 59, 59, 999); 
        this.fetchListaDespesaVeiculo(idVeiculo, dataInicio, dataFim, tipoDespesa);
      },
      fetchListaDespesaVeiculo12Mes(idVeiculo, tipoDespesa) {  
        const today = new Date();
        const dataInicio = new Date(today.getFullYear(), today.getMonth() - 11, 1);        
        const dataFim = new Date(today.getFullYear(), today.getMonth() + 1, 0);     
        dataInicio.setHours(0, 0, 0, 0);
        dataFim.setHours(23, 59, 59, 999);    
        this.fetchListaDespesaVeiculo(idVeiculo, dataInicio, dataFim, tipoDespesa);
      },
      fetchListaDespesaVeiculo(idVeiculo, dataInicio, dataFim, tipoDespesa) {  
        this.$vs.loading();    
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        if (tipoDespesa) {
          params.append('cmbTipos', tipoDespesa); // Id do Veiculo      
        } else {
          params.append('cmbVeiculos', idVeiculo); // Id do Veiculo      
        }

         
        params.append('dataInicio', dataInicio.getTime());
        params.append('dataFim', dataFim.getTime());  
        params.append('tipoData', 'dashboard');
        
        axios.post("/DespesasVeiculosRest", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                
                this.popupLista.exibir = true;
                this.popupLista.titulo = "Lista Despesas";                
                if (Array.isArray(response.data)) {
                   this.popupLista.lista = response.data;
                } else { 
                  this.popupLista.lista = [];
                  this.popupLista.lista.push(response.data);
                }

            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetch Lista Despesas - " + error); 
        })    
                          
      },           
    }
}
</script>

<style lang="scss" scoped>
  .alturaCardmax{
    height: calc(100vh - 405px);
  }

  @media print{
    *{ display: none; }
    table { display: block; }
  }
</style>

<style  lang="scss">
 .celulaRanking {
     font-size: 0.9rem;
 }
</style>
